export const Drawer = {
  baseStyle: {
    overlay: {
      bg: "grey.overlay",
    },
    dialog: {
      bg: "primary.white",
    },
  },
  sizes: {
    md: {
      dialog: { maxW: "150" },
      body: { py: { base: "6", md: "8" }, px: { base: "5", md: "8.75" } },
    },
    navigation: {
      header: { display: "flex", paddingY: "4", paddingLeft: "6", paddingRight: "0" },
      dialog: { maxW: "min(90%,376px)" },
      body: { padding: "0" },
      footer: { padding: "0" },
    },
    cart: {
      header: {
        paddingTop: { base: "2", sm: "2" },
        paddingBottom: { base: "4", sm: "2" },
        paddingLeft: { base: "5", sm: "5" },
        paddingRight: { base: "1", sm: "5" },
      },
      body: { paddingBottom: 0, paddingTop: 0, paddingX: { base: "5", sm: "5" } },
      footer: { paddingTop: "4", paddingBottom: { base: "5", sm: "5" }, paddingX: { base: "5", sm: "5" } },
      dialog: { maxW: { base: "100vw", sm: "640px" }, h: { base: "100dvh", sm: "auto" } },
    },
    // Quick add: bottom sheet on mobile (rounded top, auto height), right slide-out panel on desktop.
    quickAdd: {
      header: { paddingX: { base: "4", sm: "6" }, paddingTop: "4", paddingBottom: "3" },
      body: { paddingX: { base: "4", sm: "6" }, paddingTop: { base: "4", sm: "0" }, paddingBottom: "4" },
      footer: { paddingX: { base: "4", sm: "6" }, paddingTop: "4", paddingBottom: "5" },
      dialog: {
        maxW: { base: "100vw", sm: "500px" },
        maxH: { base: "90dvh", sm: "100dvh" },
        h: { base: "auto", sm: "100dvh" },
        borderTopRadius: { base: "20px", sm: "0" },
      },
    },
  },
  defaultProps: {
    size: "md",
  },
}
